import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconGenerateQuestionsSvg } from './IconGenerateQuestionsSvg';

export type IconGenerateQuestionsProps = UseIconProps;

export function IconGenerateQuestions(props: IconGenerateQuestionsProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <Box tagName={IconGenerateQuestionsSvg} {...iconProps} />;
}
